import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppConfig } from "src/app/AppConfig";
import { useGtm } from "src/core/hooks/useGtm";
import { logService } from "../../../core/services/logService";
import { useAuthStore } from "../../../features/auth/services/useAuthStore";
import "./AppHeader.css";
import { MainMenu } from "./components/MainMenu/MainMenu";
import { Slogan } from "./components/Slogan/Slogan";

function AppHeader() {
  const authStore = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();
  const gtm = useGtm();

  useEffect(() => {
    // route change
    logService.log("Route changed to:", location.pathname);

    document.querySelector(".scrollTop")?.scrollIntoView();

    const queryParams = new URLSearchParams(location.search);

    const email = queryParams.get("email");
    const token = queryParams.get("token");
    const route = queryParams.get("route") ?? "/";
    if (email && token) {
      logService.log("email+token+route param:", email, token, route);

      authStore.loginByToken(email, token).then(() => {
        if (route) navigate(route);
      });
    }

    gtm.event("page_view", {
      pagePath: location.pathname,
    });
  }, [location.pathname]);

  const appVersion = AppConfig.version;

  return (
    <div className="appHeader">
      <span className="version">v{appVersion}</span>

      <MainMenu />
      <Slogan />
    </div>
  );
}

export default AppHeader;
